import { render } from "./ProdutoImagens.vue?vue&type=template&id=70dfad4b&scoped=true&ts=true"
import script from "./ProdutoImagens.vue?vue&type=script&lang=ts"
export * from "./ProdutoImagens.vue?vue&type=script&lang=ts"

import "./ProdutoImagens.vue?vue&type=style&index=0&id=70dfad4b&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70dfad4b"]])

export default __exports__